module.exports = __webpack_public_path__ + "img/joauctions-cover-tr.ff1e16c3.png";